import SystemNeoUmmiaLogoImage from "../images/SystemNeoUmmiaLogoImage";
import {LogoTextSize} from "../../controllers/SystemUmmiaLogoTextController";
import {internalRoutes} from "../../constants/internalRoutes";
import SystemNeoUmmiaLogoTextImage from "../images/SystemNeoUmmiaLogoTextImage";
import {kSystemIcons} from "../../constants/icons";
import {useNavigate} from "react-router-dom";
import {useRef, useState} from "react";
import SystemAppSideBarTooltip from "../tooltips/SystemAppSideBarTooltip";

export default function SystemAppSideBarHeader({isCollapsed, setIsCollapsed, isNarrowScreen}) {
    // Used in SystemAppSideBar to display sidebar header

    // PROPERTIES
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
    const idleTimer = useRef(null);
    const handleMouseMove = (e) => {
        setShowTooltip(false);
        setTooltipPos({
            x: e.clientX,
            y: e.clientY,
        });
        clearTimeout(idleTimer.current);
        idleTimer.current = setTimeout(() => {
            setShowTooltip(true);
        }, 300); // délai "souris immobile"
    };
    const handleMouseLeave = () => {
        clearTimeout(idleTimer.current);
        setShowTooltip(false);
    };

    // BUILD
    return (
        <div className={`w-full h-[56px] px-[16px] flex ${setFlexJustify()} items-center border-b-[1px] border-greyLight3`}
             onMouseMove={handleMouseMove}
             onMouseLeave={handleMouseLeave}>
            {isNarrowScreen || isCollapsed
                ? <div className={'relative'}>
                    <SystemNeoUmmiaLogoImage logoTextSize={LogoTextSize.SMALL}
                                           onLogoPressed={() => navigate(internalRoutes.home)}
                                           extraClass={"mt-[2px]"} />
                    {showTooltip && (
                        <SystemAppSideBarTooltip showTooltip={showTooltip}
                                                 tooltip={"Accueil"}
                                                 tooltipPos={tooltipPos} />
                    )}
                  </div>
                : <SystemNeoUmmiaLogoTextImage logoTextSize={LogoTextSize.SMALL}
                                               onLogoPressed={() => navigate(internalRoutes.home)}
                                               extraClass={"mt-[3px]"} /> }
            {displayExpandButton()
                ? <div className="cursor-pointer bg-backgroundLight5 w-[24px] h-[24px] rounded-[8px] border-[1px] border-greyLight3 hover:border-greyLight5 flex justify-center items-center text-greyLight7 hover:text-greyLight11"
                       onClick={() => setIsCollapsed(prev => !prev)}>
                    <i className={`material-icons text-[20px] ${isCollapsed ? "" : "pr-[1px]"}`}>
                        {isCollapsed ? kSystemIcons.chevronRight : kSystemIcons.chevronLeft}
                    </i>
                  </div>
                : null }
        </div>
    );

    // ---- UI : Set flex justify
    function setFlexJustify() {
        return isNarrowScreen ? "justify-center" : "justify-between"
    }

    // ---- UI : Display expand button in header
    function displayExpandButton() {
        return !isNarrowScreen
    }
}